<template>
  <div>
    <CustomModal 
      :show="show"
      :title="propProtocolo ? `NR. ${propProtocolo.numero}/${ propProtocolo.ano } - ${ getStatus(propProtocolo.status) }` : ''"
      size="xl"
      backgroun
      title-button="Editar"
      title-button-cancel="voltar"
      :hide-footer="true"
      @ok="() => this.$emit('onEdit', propProtocolo)"
      @closeModal="() => this.$emit('close')">
      <div>
        <b-tabs content-class="mt-3"
                class="Resumo-border"
                align="left"
                active-nav-item-class="Resumo--tab-active">
          <b-tab title="Detalhes"
                 active>
            <ProtocoloParte :prop-protocolo="propProtocolo" />
          </b-tab>
          <b-tab title="Histórico">
            <ProtocoloHistory :prop-protocolo="propProtocolo" />
          </b-tab>
        </b-tabs>
      </div>
      <footer
        class="mt-3">
        <hr>
        <div 
          class="d-flex justify-content-between">
          <b-button class="cancelar-protocolo-btn "
                    @click="cancelarProtocolo">
            <IconSvg icon="closeCircle"
                     class="icon--sm iconBlue" />
            Cancelar protocolo
          </b-button>

          <div class="d-flex justify-content-end">
            <CustomButton text="Cancelar"
                          variant="light"
                          @click="() =>this.$emit('close')" />
            <CustomButton class="ml-3"
                          text="Editar"                                   
                          @click="() => this.$emit('onEdit', propProtocolo)" />
          </div>
        </div>
      </footer>
    </custommodal>
  </div>
</template>

<script>
// Components
  import ProtocoloParte from '@/views/SofiaRei/Protocolos/ProtocoloDetalhes/ProtocoloParte.vue'
  import CustomModal from '@/components/CustomModal/CustomModal.vue'
  import ProtocoloHistory from './ProtocoloHistory.vue'
  import CustomButton from '../../../../components/CustomButton/CustomButton.vue'

  export default {
    name: "ProtocoloDetalhes",
    components: {
      CustomModal,
      ProtocoloParte,
      ProtocoloHistory,
      CustomButton
    },
    props: {
      propProtocolo: {
        type: Object,
        default: () => ({})
      },
      show: {type: Boolean, default: false }
    },
    data () {
      return {
        protocolo: null,
      }
    },
    methods: {
      getStatus (status) {
        const obj = {
          'EM_ANDAMENTO': 'Em andamento',
          'CUMPRIDO': 'Cumprido',
          'CANCELADO': 'Cancelado'
        }

        return obj[status]
      },
      cancelarProtocolo ()  {
        this.$emit('onCancelProtocolo', this.propProtocolo)
        this.$emit('close')
      }

    }
  }
</script>

<style scoped>
  .cancelar-protocolo-btn {
    background-color: #12A0A0;
    color: black;
    border: none
  }
</style>
